<div>
  <img [src]="selected.image" class="mx-auto w-auto max-h-256"/>
</div>
<div class="flex justify-center mt-1">
  <button
    (click)="uncheck.emit(selected)"
    [title]="'catalog.multi_image_download.unselect' | transloco"
    [disabled]="disabled"
    mat-icon-button
    class="mr-2 error-icon-button"
  >
    <mat-icon>delete</mat-icon>
  </button>

  <button
    (click)="detail.emit(selected)"
    [title]="'catalog.multi_image_download.show_detail' | transloco"
    class="mr-2 primary-icon-button"
    mat-icon-button
  >
    <mat-icon>visibility</mat-icon>
  </button>
</div>
